import PropTypes from 'prop-types'
import React from 'react'

import Link from '../../templateComponents/Link'

const CartEmptyNote = ({ t, shopHref }) => (
  <div className="cart">
    <section className="section">
      <div className="wrapper">
        <div className="content">
          <h1 className="cart-headline">{t('views.storefrontView.basketPageSection.emptyState.title')}</h1>
          <div className="cart-empty-note">
            <h3>{t('views.storefrontView.basketPageSection.emptyState.explanation')}</h3>
            <p>
              <Link to={shopHref}>{t('views.storefrontView.basketPageSection.emptyState.continueShoppingLink')}</Link>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
)

CartEmptyNote.propTypes = {
  shopHref: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

export default CartEmptyNote
